var _circle, _g, _circle2, _g2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgUniqueAssets = function SvgUniqueAssets(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.333,
    cy: 20.828,
    r: 18.828,
    fill: "url(#paint0_linear_264_12700)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_264_12700)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.666,
    cy: 39.172,
    r: 18.828,
    fill: "url(#paint1_linear_264_12700)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_12700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 20,
    width: 39,
    height: 38
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.666,
    cy: 39.172,
    r: 18.828,
    fill: "url(#paint2_linear_264_12700)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_12700)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_264_12700)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.32,
    cy: 26.232,
    rx: 10.847,
    ry: 10.103,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_264_12700)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.51,
    cy: 64.097,
    rx: 11.234,
    ry: 10.463,
    fill: "#95F0FB"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.666,
    cy: 39.172,
    r: 18.578,
    stroke: "url(#paint3_linear_264_12700)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_12700",
    x1: 39.333,
    y1: 2,
    x2: 39.333,
    y2: 39.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_12700",
    x1: 20.666,
    y1: 20.345,
    x2: 20.666,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_12700",
    x1: 20.666,
    y1: 20.345,
    x2: 20.666,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_12700",
    x1: 20.666,
    y1: 20.345,
    x2: 20.666,
    y2: 37.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_264_12700",
    x: -4.161,
    y: 14.345,
    width: 49.655,
    height: 49.655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_12700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_12700",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_264_12700",
    x: -1.526,
    y: -9.871,
    width: 73.693,
    height: 72.205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_12700"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_264_12700",
    x: 3.276,
    y: 27.634,
    width: 74.468,
    height: 72.927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_12700"
  })))));
};
export default SvgUniqueAssets;